import { useState } from "react";
import { Panel, Kpi, Banner } from "@/components/common";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { api, fmt, gbp, cur } from "@/lib/api";

export function Calculator({ calc, cfg }) {
  const [stop, setStop] = useState("");
  const [res, setRes] = useState(null);
  const c = res || calc || {};
  const run = async () => {
    const { data } = await api.post("/oil/calc", { stop_distance: stop ? Number(stop) : null });
    setRes(data);
  };
  return (
    <Panel title="Execution calculator" testid="oil-calculator">
      <div className="mb-3 num text-xs text-slate-500">Max risk = {gbp(cfg.account_balance_gbp)} x {cfg.risk_pct}% / 100. Cost per {cur()} = stop distance + {cfg.ig_spread_cost_pts} pts spread cost. Stake per leg = (max risk / cost) / 2.</div>
      <div className="flex flex-wrap items-end gap-2">
        <label className="text-xs text-slate-400">Stop distance (pts, optional)<Input data-testid="calc-stop-input" value={stop} onChange={(e) => setStop(e.target.value)} className="num mt-1 h-9 w-40 bg-slate-950" /></label>
        <Button data-testid="execution-calculator-submit" variant="secondary" onClick={run}>Calculate</Button>
      </div>
      <div className="mt-4 grid grid-cols-2 gap-3 md:grid-cols-5">
        <Kpi label="Max risk" value={gbp(c.max_risk_gbp)} testid="calc-max-risk" />
        <Kpi label="Stop distance" value={`${fmt(c.stop_distance)} pts`} sub={c.stop_source} testid="calc-stop-distance" />
        <Kpi label={`Cost per ${cur()}`} value={fmt(c.cost_per_pound)} testid="calc-cost-per-pound" />
        <Kpi label="Stake per leg" value={`${cur()}${fmt(c.stake_per_leg)}/pt`} className="text-indigo-300" testid="calc-stake" sub={c.manual_override ? "manual override" : `calculated ${fmt(c.calculated_stake)}`} />
        <Kpi label="MT5 lots per leg" value={fmt(c.lots_per_leg)} testid="calc-lots" />
      </div>
      {c.below_minimum && <div className="mt-3"><Banner tone="warn" testid="calc-min-warning">The calculated stake is below the {cur()}0.50/pt broker minimum, so {cur()}0.50 is used. That risks more than your risk setting.</Banner></div>}
    </Panel>
  );
}
